import { axios, base } from '../http';

/**
 * 黑板报：按学校列出各校区配置
 * @param {Object} params { schoolId }
 */
export const getBlackboardConfigList = (params) => {
  return axios.get(`${base}/api/Blackboard/GetConfigList`, { params });
};

/**
 * 某校区可选一级类别（与排行模板一致）
 * @param {Object} params { schoolId, campusId }
 */
export const getBlackboardCategoryOptions = (params) => {
  return axios.get(`${base}/api/Blackboard/GetCategoryOptions`, { params });
};

/**
 * 保存某校区黑板报配置
 * @param {Object} data { schoolId, campusId, categoryId }
 */
export const saveBlackboardConfig = (data) => {
  return axios.post(`${base}/api/Blackboard/SaveConfig`, data);
};

/**
 * 作品分页列表
 * @param {Object} params { schoolId, yearMonth, campusId, gradeId, page, intPageSize }
 */
export const getBlackboardEntryPage = (params) => {
  return axios.get(`${base}/api/Blackboard/GetEntryPage`, { params });
};

/**
 * 得分明细（校区+年级全部班级）
 * @param {Object} params { schoolId, campusId, gradeId, yearMonth }
 */
export const getBlackboardScoreOverview = (params) => {
  return axios.get(`${base}/api/Blackboard/GetScoreOverview`, { params });
};

/**
 * 导出全校压缩包（得分表 + 作品文件夹）
 * @param {Object} params { schoolId, yearMonth }
 */
export const exportBlackboardPackage = (params) => {
  return axios.get(`${base}/api/Blackboard/ExportPackage`, { params, responseType: 'blob' });
};

/**
 * 导入预览（不写库）
 * @param {Object} data
 */
export const previewBlackboardScores = (data) => {
  return axios.post(`${base}/api/Blackboard/PreviewImport`, data);
};

/**
 * 确认导入并写入值周
 * @param {Object} data
 */
export const confirmBlackboardScores = (data) => {
  return axios.post(`${base}/api/Blackboard/ConfirmImport`, data);
};

/**
 * 撤销已结算记录
 * @param {Object} data { scoreId }
 */
export const revokeBlackboardScore = (data) => {
  return axios.post(`${base}/api/Blackboard/Revoke`, data);
};
